import { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiBookOpen, FiRefreshCw } from "react-icons/fi";
import useGetFeaturedBooks from "api/BookResource/useGetFeaturedBooks";
import useTrendingBooks from "api/BookResource/useTrendingBooks";
import useGetSpotlightedBooks from "api/BookResource/useGetSpotlightedBooks";
import HomeBook from "./HomeBook";

const tabs = [
	{ id: "picks", label: "Library picks" },
	{ id: "trending", label: "Trending this week" },
	{ id: "latest", label: "New arrivals" },
];
const FeaturedBooks = () => {
	const [selected, setSelected] = useState("picks");
	const featuredQuery = useGetFeaturedBooks({ size: 6 });
	const trendingQuery = useTrendingBooks({ period: "weekly", limit: 6 });
	const spotlightQuery = useGetSpotlightedBooks();
	const spotlight = spotlightQuery.data?.data;
	const booksByTab = {
		picks: Array.isArray(spotlight) && spotlight.length ? spotlight : featuredQuery.data?.recommendedBooks,
		trending: trendingQuery.data,
		latest: featuredQuery.data?.latestBooks,
	};
	const query = selected === "trending" ? trendingQuery : featuredQuery;
	const books = Array.isArray(booksByTab[selected]) ? booksByTab[selected].slice(0, 6) : [];
	const loading = books.length === 0 && (query.isLoading || (selected === "picks" && spotlightQuery.isLoading));
	const failed = !loading && query.isError && books.length === 0;

	const navigateTabs = (event) => {
		const current = tabs.findIndex((tab) => tab.id === selected);
		const next = { ArrowRight: (current + 1) % tabs.length, ArrowLeft: (current + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
		if (next === undefined) return;
		event.preventDefault();
		setSelected(tabs[next].id);
		event.currentTarget.querySelectorAll('[role="tab"]')[next].focus();
	};

	return (
		<section id="discover-books" className="home-section home-discover" aria-labelledby="discover-heading">
			<div className="home-wrap">
				<div className="home-section-heading"><div><p className="home-eyebrow">ON THE AKELLO BOOKSHELF</p><h2 id="discover-heading">Find your next favourite.</h2><p>A few discoveries from our shelves to yours.</p></div><Link to="/books" className="home-text-link">View all books <FiArrowRight aria-hidden="true" /></Link></div>
				<div className="home-book-tabs" role="tablist" aria-label="Discover books" onKeyDown={navigateTabs}>
					{tabs.map(({ id, label }) => <button type="button" key={id} id={`home-tab-${id}`} role="tab" aria-selected={selected === id} aria-controls="home-book-panel" tabIndex={selected === id ? 0 : -1} onClick={() => setSelected(id)}>{label}</button>)}
				</div>
				<div id="home-book-panel" role="tabpanel" aria-labelledby={`home-tab-${selected}`} tabIndex={0} aria-busy={loading}>
					{loading ? <div className="home-book-grid" role="status"><span className="home-sr-only">Loading books</span>{Array.from({ length: 6 }, (_, index) => <div className="home-book-skeleton" key={index} aria-hidden="true"><div /><span /><span /></div>)}</div>
						: failed ? <div className="home-book-empty" role="status"><FiBookOpen aria-hidden="true" /><h3>We couldn’t load these books.</h3><p>Try again, or head to the catalogue to find your next read.</p><div className="home-actions"><button type="button" className="home-button home-button-outline" disabled={query.isFetching} onClick={() => query.refetch()}><FiRefreshCw aria-hidden="true" />{query.isFetching ? "Trying again…" : "Try again"}</button><Link to="/books" className="home-text-link">Browse the catalogue <FiArrowRight aria-hidden="true" /></Link></div></div>
							: books.length ? <div className="home-book-grid">{books.map((book) => <HomeBook key={book.id} book={book} />)}</div>
								: <div className="home-book-empty" role="status"><FiBookOpen aria-hidden="true" /><h3>More discoveries are waiting.</h3><p>Explore the catalogue while we put together this selection.</p><Link to="/books" className="home-text-link">Browse all books <FiArrowRight aria-hidden="true" /></Link></div>}
				</div>
			</div>
		</section>
	);
};
export default FeaturedBooks;
